import { router } from './router';
import LinkToDebrief from 'ff/debrief/router/links/LinkToDebrief';
import LinkToTracklog from 'ff/debrief/router/links/LinkToTracklog';
import LinkToShared from 'ff/debrief/router/links/LinkToShared';
export { LinkToDebrief, LinkToTracklog, LinkToShared };
export default router;
